import { isEmpty } from '@ember/utils';
import * as d3 from 'd3';
import Money from '@square/dashboard-money/models/money';
export function xDomain(data) {
  return data.flat().map(d => d.x);
}
export function yDomain(data) {
  return [0, d3.max(data.flat(), d => d.y)];
}

// Determines the longest y axis label (includes chars like currency code and negative sign)
export function yMaxLabel(yDomain, yTickFormatType) {
  const max = yDomain[1];
  if (max === 0) {
    return '';
  } else {
    const ticks = d3.scale.linear().domain(yDomain).ticks();
    const lastTick = ticks[ticks.length - 1];
    const tickIncrement = lastTick - ticks[ticks.length - 2];

    // If the last tick does not include the largest number, d3 will eventually add another tick that we have to account for
    const maxAmount = max > lastTick ? lastTick + tickIncrement : lastTick;
    return yTickFormatType ? Money.fromCents(maxAmount).get(yTickFormatType) : maxAmount;
  }
}
export function yScale(yDomain, yRange) {
  return d3.scale.linear().range(yRange).domain(yDomain).nice();
}
export function xTickFormat(data) {
  return (d, i) => data[0][i].tick;
}
export function yGridTickSize(width) {
  return -width;
}
export function dataForHover(data) {
  if (isEmpty(data)) {
    return [];
  }
  return data[0].map((summary, index) => {
    const maxY = Math.max(...data.map(point => point[index].y));
    return {
      x: summary.x,
      y: maxY,
      tooltipSections: data.map(point => {
        return {
          heading: point[index].tooltipHeading,
          amount: point[index].tooltipAmount
        };
      })
    };
  });
}